import PlainButton from '../components/PlainButton';
import '.././styles/PortfolioIndex.scss';
import Contact from '../components/Contact';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { projectsArray } from '../utils/projects';
import { motion } from 'framer-motion';

function PortfolioIndex({ isMenuOpen, toggleMenu }) {
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.2, duration: 0.6 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		visible: { opacity: 1, y: 0 },
	};

	const portfolio = projectsArray.map((project) => {
		return (
			<motion.div
				className="Portfolio-outer-grid"
				key={project.id}
				variants={itemVariants}
				transition={{ duration: 0.6, ease: 'easeOut' }}
			>
				<div
					className={`image-cover ${project.id % 2 === 0 ? 'Grid-order' : ''}`}
				>
					<img
						src={`/images/${project.image}`}
						alt="Preview of project"
						className={`Project-image-cover`}
					/>
				</div>

				<div className="Portfolio-inner-grid">
					<hr className="First" />
					<div className="Portfolio-main-text-wrap">
						<h1 className="Main-text">{project.title}</h1>
					</div>
					<p className="Portfolio-Paragraph-text">{project.description}</p>
					<PlainButton
						text={'View Project'}
						slug={project.slug.toLowerCase()}
					/>
					<hr className="Second" />
				</div>
			</motion.div>
		);
	});

	return (
		<>
			<div className="Container">
				<div className="Wrapper">
					<Nav toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />

					<motion.div
						className="Portfolio-container"
						variants={containerVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true, amount: 0.2 }}
					>
						{portfolio}
					</motion.div>

					<Contact />
				</div>
			</div>
			<Footer />
		</>
	);
}

export default PortfolioIndex;
